import * as React from 'react';
import classNames from 'classnames';

interface Props {
    /* Has the field been touched */
    touched?: boolean;
    /* Error message to be displayed */
    error?: boolean;
    /** Adds m-form-row--full-width class */
    fullWidth?: boolean;
    /* Additional classes to be applied */
    className?: string;
    children?: React.ReactNode; // Add children property
}

export class FieldRow extends React.Component<Props> {

    render() {
        const { touched, error, className, fullWidth } = this.props;
        const classes = classNames(
            'm-form-row',
            className,
            { 'm-form-row--full-width': fullWidth },
            { 'is-error': touched && error },
            { 'is-valid': touched && !error }
        );
        return (
            <fieldset
                data-testid="field-row"
                className={classes}>
                {this.props.children}
            </fieldset>
        );
    }
}